import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Col,
  CardBody,
  Label,
  Input
} from "reactstrap";
import { useLocation } from "react-router-dom";
import { postEmployeesAdminCreate, postEmployeesAdminCreateAddress } from "../../../helpers/api_rombo_helper";
import i18n from "../../../i18n";
import { useDispatch } from "react-redux";
import { map } from "lodash";
import { useNavigate } from 'react-router-dom';
import Places from "../../Google/Places";
import Map from "../../Google/Map";

const Step2 = ({ step, setStep, token, setAddresses, setSelectedAddress, selectedAddress, addresses, identifier, name, email, depot, infoUser, phone, company, setErrorAlert, setErrorAlertMessage, navigationState }) => {

  const dispatch = useDispatch();
  const history = useNavigate();
  const location = useLocation();
  const [hiddenOne, setHiddenOne] = useState(false);
  const [nameAddress, setNameAddress] = useState(null);
  const [titleAdress, setTitleAdress] = useState(i18n.t("TitleAddress", { typeAddress: i18n.t("Predefined"), address: "" }));
  const [checkLatLong, setCheckLatLong] = useState(false);
  const [selected, setSelected] = useState({ lng: -99.1446503251791, lat: 19.46416132507601 });
  const [rowsScale, setRowsScale] = useState([{ id: 0, latLon: false, addresssMap: true, address: { location: { lon: -99.1446503251791, lat: 19.46416132507601 } } }]);

  useEffect(() => {

  }, [dispatch]);

  useEffect(() => {

  }, [company]);

  useEffect(() => {
    return () => {
      sessionStorage.removeItem("employeeRedirectTo");
    };
  }, []);

  const onClickLatLong = () => {
    setCheckLatLong(!checkLatLong);
  };

  const onBackStep = () => {
    setStep(step - 1);
  };

  const onChangeNameAddress = (name) => {
    setNameAddress(name);
  };

  const handleAddRowScale = () => {
    const newRowScale = {
      id: rowsScale[rowsScale.length - 1].id + 1,
      latLon: false,
      addresssMap: true,
      address: { location: { lon: -99.1446503251791, lat: 19.46416132507601 } }
    };
    setRowsScale([...rowsScale, newRowScale]);
  };

  const handleRemoveRowScale = (id) => {
    if (rowsScale.length == 1) {
      return;
    }

    const updatedRows = rowsScale.filter((row) => row.id !== id);
    setRowsScale(updatedRows);
  };

  const onClickLatLongAddreses = (e, formRow) => {
    let arr = rowsScale;
    let address = arr.filter(function(opt) {
      return opt.id === formRow.id;
    }).shift();
    if (address) {
      arr.splice(arr.indexOf(address), 1);
      address.latLon = (e.target && e.target.checked) ? true : false;
      arr.push(address);
      arr.sort((a, b) => (a.id > b.id) ? 1 : -1);
      setRowsScale([...arr]);
    }
  };

  const onChangeAddScalesRow = (formRow, valInput, type) => {
    let rowScale = null;
    let arrScales = rowsScale;
    let address = type == "address" ? valInput.target.value : "";
    let lon = type == "latitude" ? valInput.target.value : "";
    let lat = type == "longitude" ? valInput.target.value : "";
    let addressName = type == "addressName" ? valInput.target.value : "";
    if (arrScales.length == 0) {
      rowScale = {
        id: formRow.id,
        name: addressName,
        latLon: false,
        addresssMap: true,
        address: { description: address, location: { lat, lon } }
      };
      arrScales.push(rowScale);
    } else {
      rowScale = arrScales.filter(function(opt) {
        return opt.id === formRow.id;
      }).shift();
      if (rowScale) {
        arrScales.splice(arrScales.indexOf(rowScale), 1);
        rowScale.address.description = type == "address" ? valInput.target.value : rowScale.address.description;
        rowScale.name = type == "addressName" ? valInput.target.value : rowScale.name;
        rowScale.address.location.lat = type == "latitude" ? parseFloat(valInput.target.value) : rowScale.address.location.lat;
        rowScale.address.location.lon = type == "longitude" ? parseFloat(valInput.target.value) : rowScale.address.location.lon;
        arrScales.push(rowScale);
      } else {
        rowScale = {
          id: formRow.id,
          name: addressName,
          latLon: false,
          addresssMap: true,
          address: { description: address, location: { lat, lon } }
        };
        arrScales.push(rowScale);
      }
    }
    setRowsScale([...arrScales]);
  };

  const onCreateEmployee = () => {
    let newAddresses = [];
    newAddresses.push({ name: nameAddress, address: selectedAddress });

    if (selectedAddress.description) {
      rowsScale.forEach((address) => {
        if (address.name) {
          newAddresses.push({ name: address.name, address: address.address });
        }
      });
      setAddresses([...newAddresses]);

      let body = {
        name: name,
        email: email,
        depot: depot,
        phone: phone,
        travel_limit: 0,
        monthly_amount_limit: 0,
        job_position: "Default",
        cost_center_id: null,
        partner_id: String(company?.value ?? infoUser.partner_id),
        latitude: selectedAddress.location.lat,
        longitude: selectedAddress.location.lon,
        policies: {
          parking: false,
          toll: false,
        },
        partner_name: String(company?.label ?? infoUser.partner_name),
      };

      if (identifier && identifier.trim() !== "") {
        body.identifier = identifier;
      }

      if (infoUser.is_staff) {
        body.field_key = "string";
        body.field_type = "NUMERIC";
        body.field_value = "string";
      }

      postEmployeesAdminCreate(token, body)
        .then((responseEmp) => {
          localStorage.setItem("notify", "true");
          localStorage.setItem("headerText", i18n.t("CreatedEmployee"));
          localStorage.setItem("bodyText", i18n.t("SuccessCreatedEmployee"));

          postEmployeesAdminCreateAddress(token, responseEmp.id, { addresses: newAddresses })
            .then(() => {
              const redirectPath = sessionStorage.getItem("employeeRedirectTo");
              if (redirectPath) {
                sessionStorage.removeItem("employeeRedirectTo");
                history(redirectPath);
              } else {
                history("/employees");
              }
            })
            .catch((error) => {
              console.error("Error - postEmployeesAdminCreateAddress - ", error);
            });
        })
        .catch((error) => {
          console.error("Error - postEmployeesAdminCreate - ", error);
          setErrorAlertMessage(error.response?.data?.detail ?? error.message);
          setErrorAlert(true);
        });
    } else {
      setErrorAlert(true);
      setErrorAlertMessage(i18n.t("PleaseFillDefaultAddress"));
    }
  };

  const partnerId = String(company?.value ?? infoUser.partner_id);

  return (
    <Fragment>
      <CardBody>
        <Row>
          <Col xs={12} xxl={12} xl={12} className="pb-3">
            <h6 className="employees-form-title">{i18n.t("Addresses")}</h6>
            <span className="employees-form-text">{i18n.t("DescAddresses")}</span>
          </Col>
          <Col xs={12} xxl={6} xl={6} className="row h-100">
            <Col xs={12} xxl={6} xl={6} className="">
              <Label className="employees-form-subtitle" htmlFor="nameInput">{i18n.t("AddressName")}</Label>
              <Input
                type="text"
                onChange={(e) => onChangeNameAddress(e.target.value)}
                name="name"
                className="form-control"
                id="nameInput"
                placeholder={i18n.t("EnterAddressName")}
              />
            </Col>
            <Col xs={12} xxl={6} xl={6} className="">
              <Label className="employees-form-subtitle" htmlFor="defaultAddressInput">{i18n.t("DefaultAddress")}</Label>
              <Places
                selected={selected}
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
                typeAddress={'predefined'}
                setSelected={setSelected}
                setTitleAdress={setTitleAdress}
                disabled={checkLatLong}
                id={"defaultAddress"}
                hiddenOne={hiddenOne}
                setRowsScale={setRowsScale}
                rowsScale={rowsScale}
                setHiddenOne={setHiddenOne}
                placeholder={i18n.t("WriteDefaultaddress")}
              />
            </Col>
            <div className="employees-lat-lng-container">
              <input
                className="employees-form-checkbox"
                type="checkbox"
                id="addUseLatLong"
                name="addUseLatLong"
                onClick={onClickLatLong}
              />
              <label
                className="employees-form-checkbox-label"
                htmlFor="addUseLatLong"
              >
                {i18n.t("AddUseLatLong")}
              </label>
            </div>
            {checkLatLong &&
              <Col xxl={12} md={12} xs={12} className="row">
                <Col xxl={6} md={6} xs={12}>
                  <Label className="latitude" htmlFor="latitudeInput">{i18n.t("Latitude")}</Label>
                  <Input
                    type="number"
                    name="latitude"
                    className="form-control"
                    id="latitudeInput"
                    placeholder={i18n.t("WriteLatitude")}
                  />
                  <p/>
                </Col>
                <Col xxl={6} md={6} xs={12}>
                  <Label className="longitude" htmlFor="longitudeInput">{i18n.t("Longitude")}</Label>
                  <Input
                    type="number"
                    name="longitude"
                    className="form-control"
                    id="longitudeInput"
                    placeholder={i18n.t("WriteLongitude")}
                  />
                </Col>
              </Col>
            }
            {partnerId !== "7784" && (
              <Col xs={12} xxl={12} xl={12} className="pb-3">
                <div className="request-separator" />
                <div className="inner-repeater mb-4">
                  <h6 className="employees-form-title">{i18n.t("TitleAddresses")}</h6>
                  <span className="employees-form-text">{i18n.t("DescTitleAddresses")}</span>
                  <p/>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      {(rowsScale).map((formRow, key) => (
                        <tr key={key}>
                          <td>
                            <Row>
                              <Col xs={12} xxl={6} xl={6} className="">
                                <Label className="visually" htmlFor="scaleAddressInput">
                                  {i18n.t("AdditionalAddressName") + " " + (formRow.id + 1)}
                                </Label>
                                <Input
                                  type="text"
                                  name="addresses[][name]"
                                  className="form-control"
                                  value={formRow.name}
                                  id={`name-${key}`}
                                  placeholder={i18n.t("AddressName")}
                                  onChange={(e) => onChangeAddScalesRow(formRow, e, "addressName")}
                                />
                              </Col>
                              <Col xs={12} xxl={6} xl={6} className="">
                                <div className="col-sm-auto mb-2">
                                  <Label className="visually" htmlFor="scaleAddressInput">
                                    {i18n.t("AdditionalAddress") + " " + (formRow.id + 1)}
                                  </Label>
                                  <Places
                                    selected={selected}
                                    selectedAddress={null}
                                    setSelectedAddress={null}
                                    typeAddress={'array'}
                                    setSelected={null}
                                    setTitleAdress={setTitleAdress}
                                    disabled={checkLatLong}
                                    id={`address-${key}`}
                                    setRowsScale={setRowsScale}
                                    rowsScale={rowsScale}
                                    addressRow={formRow}
                                    hiddenOne={hiddenOne}
                                    setHiddenOne={setHiddenOne}
                                    placeholder={i18n.t("Address")}
                                  />
                                </div>
                              </Col>
                            {/*<Col xxl={2} md={2} xs={2}>
                              <div className="d-grid mt-4">
                                <Link
                                  className="delete-scale-buttom"
                                  onClick={() => handleRemoveRowScale(formRow.id)}>
                                  <i className="fa fa-trash text-danger"></i>
                                </Link>
                              </div>
                            </Col>*/}
                              <Col xxl={12} md={12} xs={12}>
                                <div className="employees-lat-lng-container">
                                  <input
                                    className="employees-form-checkbox"
                                    type="checkbox"
                                    id={`addUseLatLong-${key}`}
                                    name={`addUseLatLong-${key}`}
                                    onClick={(e) => onClickLatLongAddreses(e, formRow)}
                                  />
                                  <label
                                    className="employees-form-checkbox-label"
                                    htmlFor={`addUseLatLong-${key}`}
                                  >
                                    {i18n.t("AddUseLatLong")}
                                  </label>
                                </div>
                                {formRow.latLon &&
                                  <Col xxl={12} md={12} xs={12} className="row">
                                    <Col xxl={6} md={6} xs={12}>
                                      <Label className="latitude" htmlFor="latitudeInput">{i18n.t("Latitude")}</Label>
                                      <Input
                                        type="number"
                                        name="latitude"
                                        defaultValue={formRow.address.location.lat}
                                        onChange={(e) => onChangeAddScalesRow(formRow, e, "latitude")}
                                        className="form-control"
                                        id="latitudeInput"
                                        placeholder={i18n.t("WriteLatitude")}
                                      />
                                    </Col>
                                    <Col xxl={6} md={6} xs={12}>
                                      <Label className="longitude" htmlFor="longitudeInput">{i18n.t("Longitude")}</Label>
                                      <Input
                                        type="number"
                                        name="longitude"
                                        defaultValue={formRow.address.location.lon}
                                        onChange={(e) => onChangeAddScalesRow(formRow, e, "longitude")}
                                        className="form-control"
                                        id="longitudeInput"
                                        placeholder={i18n.t("WriteLongitude")}
                                      />
                                    </Col>
                                  </Col>
                                }
                              </Col>
                              <div className="request-separator" />
                            </Row>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                {/*{rowsScale.length < 4 && <Link
                  className="text-dark"
                  onClick={() => {
                    handleAddRowScale();
                  }}
                >
                  <i className="bx bx-plus" />
                  {i18n.t("AddAddress")}
                </Link>}*/}
                </div>
              </Col>
            )}
          </Col>
          <Col xs={12} xxl={6} xl={6} className="row h-100">
            <Map
              nameTitle={titleAdress}
              setNameTitle={setTitleAdress}
              selected={selected}
              setSelected={setSelected}
              setSelectedAddress={setSelectedAddress}
              selectedAddress={selectedAddress}
              hiddenOne={hiddenOne}
              setHiddenOne={setHiddenOne}
              addressRow={null}
              type={'one'}
              id={"defaultAddress"}
            />
            {
              map(rowsScale, (address, key) => (
                <Map
                  key={key}
                  nameTitle={i18n.t("TitleAddress", { typeAddress: `${i18n.t("Additional")} ${address.id + 1}`, address: address.address.description })}
                  setNameTitle={i18n.t("TitleAddress", { typeAddress: `${i18n.t("Additional")} ${address.id + 1}`, address: address.address.description })}
                  selected={{ lng: address.address.location.lon, lat: address.address.location.lat }}
                  setSelected={null}
                  hiddenArray={address.addresssMap}
                  setRowsScale={setRowsScale}
                  rowsScale={rowsScale}
                  addressRow={address}
                  hiddenOne={false}
                  type={'array'}
                  id={address.id}
                />
              ))
            }
          </Col>
          <Col xxl={2} md={2} xs={12} className="d-flex pt-3">
            <button onClick={() => onCreateEmployee()} className="btn btn-request fs-11">{i18n.t("EmployeeCreate")}</button>
            <button onClick={() => onBackStep()} className="btn btn-go-back border fs-11 mx-2">{i18n.t("Back")}</button>
          </Col>
        </Row>
      </CardBody>
    </Fragment>
  );
};

export default Step2;
